export default __webpack_public_path__ + "static/HolidayInnBrandPortfolio-9e8539f27ebbf24926a15dd8f713eb80.png";